import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareerComponent {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().career);
  
  benefits = computed(() => this.t().benefits);
  
  benefitIcons = [
    'M12 14l9-5-9-5-9 5 9 5z',
    'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l4 4m0 0l4 4m-4-4L11 9m0 0l4 4m-4-4l-4-4m12 12l-4-4m0 0l-4-4m4 4l-4 4',
    'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
  ];
}